<div class="relative flex min-w-0 flex-1 items-center">
  <input
    type="text"
    matAutocompleteTrigger
    [value]="searchTerm() | translate"
    [placeholder]="placeholder() | translate"
    [matAutocomplete]="auto"
    [disabled]="disabled()"
    (input)="onInput($event.target.value)"
    class="w-full min-w-0 rounded-lg border border-gray-300 bg-white px-3 py-2 pr-7 text-[12px] text-gray-600 normal-case outline-none placeholder:text-gray-400 focus:border-[#4f79b7] focus:ring-1 focus:ring-[#4f79b7] disabled:cursor-not-allowed disabled:border-dashed disabled:bg-gray-50 disabled:text-gray-500"
  />
  @if (!disabled()) {
    @if (searchTerm() !== '') {
      <mat-icon (click)="onClear()" class="absolute right-2 !h-4 !w-4 cursor-pointer !text-[16px] text-gray-400 hover:text-gray-600">close</mat-icon>
    } @else {
      <mat-icon class="pointer-events-none absolute right-2 !h-4 !w-4 !text-[16px] text-gray-400">arrow_drop_down</mat-icon>
    }
  }

  <mat-autocomplete #auto (optionSelected)="onSelect($event.option.value)">
    @if (showBlankOptions() && searchTerm() === '') {
      <mat-option [value]="'IOT_DICTIONARY.BLANK'" class="!text-[12px]">
        <ng-container
          [ngTemplateOutlet]="optionLabel"
          [ngTemplateOutletContext]="{ label: 'IOT_DICTIONARY.BLANK', active: searchTerm() === 'IOT_DICTIONARY.BLANK' }"
        />
      </mat-option>
      <mat-option [value]="'IOT_DICTIONARY.NOT_BLANK'" class="!text-[12px]">
        <ng-container
          [ngTemplateOutlet]="optionLabel"
          [ngTemplateOutletContext]="{ label: 'IOT_DICTIONARY.NOT_BLANK', active: searchTerm() === 'IOT_DICTIONARY.NOT_BLANK' }"
        />
      </mat-option>
    }
    @for (option of filteredOptions(); track option) {
      <mat-option [value]="option" class="!text-[12px]">
        <ng-container [ngTemplateOutlet]="optionLabel" [ngTemplateOutletContext]="{ label: option, active: option === searchTerm() }" />
      </mat-option>
    }
  </mat-autocomplete>
</div>

<ng-template #optionLabel let-label="label" let-active="active">
  <span class="block min-w-0 truncate" [matTooltip]="label | translate" matTooltipClass="regular-tooltip" matTooltipPosition="right">{{
    label | translate
  }}</span>
</ng-template>
